import {
    Box,
    InputGroup,
    Stack,
    InputLeftElement,
    Button,
    Input,
    useDisclosure,
    Spinner
} from "@chakra-ui/react";
import { MdSearch, MdAdd } from "react-icons/md";
import Card from "components/card/Card";
import { useHistory } from "react-router-dom";
import { getAPIEndpoint } from "views/config";
import { useEffect, useState } from "react";
import axios from "axios";
import { logger } from "views/models/logging";
import { AddClient } from "./components/AddClient";
import { Clients } from "./components/Clients";
import { ToastContainer, toast } from 'react-toastify';
import { ConfirmDeleteModal } from "components/modal/ConfirmDeleteModal";
import { EditClient } from "./components/EditClient";

export default function ClientMgt({ showOptions = true, showReportBtn = false, showReportModal }) {
    const [agentData, setAgentData] = useState([]);
    const [agentDataTmp, setAgentDataTmp] = useState([]);
    const [isLoading, setIsloading] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    let navigate = useHistory();
    const { isOpen: isAddOpen, onOpen: onAddOpen, onClose: onAddClose } = useDisclosure()
    const { isOpen: isDelOpen, onOpen: onDelOpen, onClose: onDelClose } = useDisclosure()
    const { isOpen: isEditOpen, onOpen: onEditOpen, onClose: onEditClose } = useDisclosure()
    const [selectedAgent, setSelectedAgent] = useState(null);
    const [selectedAgentData, setSelectedAgentData] = useState(null);
    const [creator, setCreator] = useState('');
    const [token, setToken] = useState(null);

    useEffect(() => {
        const clientInfo = sessionStorage.getItem('clientInfo');
        const key = sessionStorage.getItem('token');
        if (clientInfo) {
            const { clientName, role } = JSON.parse(clientInfo);
            if (role === 'User') {
                navigate.push('/auth');
            }
            setCreator(clientName);
            setToken(key);

            getAgents(key);
        }
        else
            navigate.push('/auth');

    }, []);

    const getAgents = async (key) => {
        setIsloading(true);

        try {
            const apiHeader = {
                headers: {
                    "authorization": `Bearer ${key}`
                }
            }

            const response = await axios.get(getAPIEndpoint('agent'), apiHeader);
            if (response) {
                const { status, data } = response.data;
                if (status === 'success' && data) {
                    setAgentData(data);
                    setAgentDataTmp(data);
                }
                else {
                    setAgentData([]);
                    setAgentDataTmp([]);
                }
            }

        } catch (error) {
            await logger({ task: "Get Agents", error: error.toString() });
        }
        setIsloading(false);
    }

    const deleteFn = (agentId) => {
        setSelectedAgent(agentId);
        onDelOpen();
    }

    const editFn = (selectedData) => {
        setSelectedAgentData(selectedData);
        onEditOpen();
    }

    const deleteAgent = async (key) => {
        try {
            setIsDeleting(true);

            const apiHeader = {
                headers: {
                    "authorization": `Bearer ${key}`
                }
            }

            const response = await axios.post(getAPIEndpoint('agent-delete'), { agentId: selectedAgent, creator }, apiHeader);
            if (response) {
                const { status } = response.data;
                if (status === 'success') {
                    await getAgents(key);
                    onDelClose();
                }
                else {
                    toast.error('Sorry, we are unable to delete client data at this time. Please try again later.');
                }
            }

        } catch (error) {
            await logger({ task: "Delete Agent", error: error.toString() });
        }
        setIsDeleting(false);
    }

    const modalPropsDel = {
        isOpen: isDelOpen,
        onClose: onDelClose,
        deleteFn: deleteAgent,
        tag: 'client',
        isDeleting,
        authKey: token
    }

    const clientProps = {
        data: agentData,
        deleteFn,
        editFn,
        showOptions,
        showReportBtn,
        showReportModal
    }

    const editProps = {
        isOpen: isEditOpen,
        onClose: onEditClose,
        clientData: selectedAgentData,
        refreshData: getAgents,
        creator,
        authKey: token
    }

    const handleSearch = (e) => {
        if (agentDataTmp.length > 0) {
            setAgentData(agentDataTmp.filter(v => v.agentName.toLowerCase().includes(e.target.value.toLowerCase())));
        }
    }

    return (
        <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
            <Stack spacing={5}>
                <Card
                    direction='column'
                    w='100%'
                    h='75px'
                    overflowX={{ sm: "scroll", lg: "hidden" }}>
                    <Stack direction='row' px={5} mt={'-5px'}>
                        <InputGroup borderColor='white'>
                            <InputLeftElement
                                pointerEvents='none'
                                pt={2}
                                children={<MdSearch color='gray' size={24} />}
                            />
                            <Input type='text' onChange={handleSearch} placeholder='Search' size='lg' focusBorderColor='white' _hover={{
                                borderColor: "white"
                            }} />
                        </InputGroup>
                        <Button
                            fontSize={{ base: "12px", md: "15px" }}
                            color={"white"}
                            bg={"#0C7FE9"}
                            _hover={{
                                bg: "#3c98ed"
                            }}
                            w={'200px'}
                            h={'45px'}
                            leftIcon={<MdAdd size={"22px"} />}
                            onClick={onAddOpen}
                        >
                            Add New Client
                        </Button>
                    </Stack>
                </Card>
                <Clients {...clientProps} />
            </Stack>
            {isLoading ? <Spinner /> : <AddClient isOpen={isAddOpen} onClose={onAddClose} refreshData={getAgents} creator={creator} authKey={token} />}
            {selectedAgentData && <EditClient {...editProps} />}
            {selectedAgent && <ConfirmDeleteModal  {...modalPropsDel} />}
            <ToastContainer />
        </Box>
    );
}